import { render, staticRenderFns } from "./HistoricoCliente.vue?vue&type=template&id=557263e0&"
import script from "./HistoricoCliente.vue?vue&type=script&lang=js&"
export * from "./HistoricoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports